import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GraphQLComparision } from '../../../../enums/GraphQLComparision.enum';
import { ControlWidgetService, EveReportingControlWidgetWidget } from '../../../../services/ControlWidgetService.service';
import { GraphQLConnector, GraphQLFilter, IGraphQlService } from '../../../../services/GraphQl/IGraphQL.service';
import {  EveReportingWidgetType } from '../../widget.component';

export interface DialogData {
  wheres: GraphQLFilter[];
  header: string;
  selectedEveUsers: any[]
}


@Component({
  selector: 'eve-user-autocomplete-input-control-widget',
  templateUrl: 'eve-user-autocomplete-input-control-widget.component.html',
  styleUrls: ['./eve-user-autocomplete-input-control-widget.component.css']
})
export class EveUserAutoCompleteInputControlWidgetComponent implements OnInit, OnDestroy {

  @Input()
  widget?: EveReportingControlWidgetWidget = null;

  widgetTypes = EveReportingWidgetType;

  controlValue: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);


  selectedEveUsers: any[];
  eveUsers: any[];
  

  constructor(
    public controlWidgetService: ControlWidgetService,
    public graphQlService: IGraphQlService,
    @Inject(APP_BASE_HREF) public baseHref: string,
  ) {
   
  }

  onModelChange($event: any[]) {
    this.selectedEveUsers = $event;

    this.controlValue.next(
      this.selectedEveUsers.map(eu => eu.eveUserName.split("@")[0])
    );

    
  }
  
    

  search(event) {
    
    this.graphQlService.getGraphQlResults({
      dataset: "eveUsersPage",
      selects: [
        {
          field: "eveUserId",
          arguments: null
        },
        {
          field: "eveUserName",
          arguments: null
        },
        {
          field: "firstName",
          arguments: null
        },
        {
          field: "surname",
          arguments: null
        },
        {
          field: "avatarImageId",
          arguments: null
        }
      ],
      wheres: [
        { path: "eveUserName", comparison: GraphQLComparision.CONTAINS, value: event.query, connector: GraphQLConnector.OR } as GraphQLFilter,
       // { path: "firstName", comparison: GraphQLComparision.CONTAINS, value: event.query, connector: GraphQLConnector.OR } as GraphQLFilter,
        //{ path: "surname", comparison: GraphQLComparision.CONTAINS, value: event.query, connector: GraphQLConnector.OR } as GraphQLFilter,
      ],
      groupBys: [],
      orderBy: [{ path: "firstName", descending: false }, { path: "surname", descending: false }],
      page: 0,
      pageSize: 10
    }).subscribe(response => this.eveUsers = response.data.eveUsersPage.items)
  } 
    

  ngOnInit(): void {

    if (this.widget != null && this.widget.controlWidgetId == null) this.widget.controlWidgetId = crypto.randomUUID();

    this.controlWidgetService.addControlWidget(this);


  }

  ngOnDestroy(): void {
    this.controlWidgetService.removeControlWidget(this);
  }

  
}


